import React, { useEffect } from 'react'
import { useStore } from "../../../stores/store";

function Dashboard() {
  const { mainStore } = useStore();

  useEffect(() => {
    mainStore.setMenuType(mainStore.SettingsDashboardMenuType);
    mainStore.setMenuNo(mainStore.SettingsDashboardMenuNo);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <h4>ADMIN DASHBOARD</h4>
    </div>

  )
}

export default Dashboard